import React from 'react';
import moment from 'moment';

/**
 * date formats
 */
// define common date formats here
const dateFormats = {
  date: 'DD/MM/yyyy',
  date1: 'Do MMM YYYY',
  time: 'hh:mma',
  datetime: 'DD/mm/yyyy - HH:mm',
  timestamp: 'Do MM YYYY  hh:mma',
  calendarDate: 'yyyy-MM-DD',
};

const DateWithTime = ({ timestamp }) => {
  let date = moment.parseZone(timestamp).utc().format(dateFormats.date);
  let time = moment.parseZone(timestamp).utc().format(dateFormats.time);

  return (
    <>
      {date} &middot; {time}
    </>
  );
};

const ViewingDate = ({ timestamp }) => {
  let date = moment.parseZone(timestamp).utc().format(dateFormats.date1);
  let time = moment.parseZone(timestamp).utc().format(dateFormats.time);

  return (
    <>
      {date} at {time}
    </>
  );
};

const calendarDate = (timestamp) => {
  return moment.parseZone(timestamp).utc().format(dateFormats.calendarDate);
};

const getMonth = (timestamp) => {
  return moment.parseZone(timestamp).utc().format('MMMM');
};

export { DateWithTime, ViewingDate, calendarDate, getMonth };
